import { TAppointment } from '../appointments/types.ts';
import { EUserRole } from '../authentication/types.ts';

/** @lintignore */
export type TInsuranceStatus = 'active';

/** @lintignore */
export type TPatient = {
    id: string;
    avatarUrl?: string;
    fullName: string;
    age: number;
    dateOfBirth: string;
    diagnosis: string;
    appointments: TAppointment[];
    insuranceInfo: {
        provider: string;
        policyNumber: string;
        status: TInsuranceStatus;
    };
};

export interface IPatientListItem {
    pID: number;
    pName: string;
    pTherapies?: null;
    pAge?: string;
    pTherLocation?: null;
    statusID?: null;
    statusDescription?: null;
    avatar?: string;
}

export interface IPatientListResponse {
    page: number;
    pages: number;
    per_page: number;
    total: number;
    patients: IPatientListItem[];
}

export interface IPatientPageData {
    page: number;
    pages: number;
    per_page: number;
    total: number;
    patients: IPatientListItem[];
}

export interface IPatientInfiniteQueryData {
    pages: IPatientPageData[];
    pageParams: unknown[];
}

export interface IGetPatientResponse {
    pID: number;
    pFirstName: string;
    pLastName: string;
    pMiddleInit: string | null;
    pSuffix: string | null;
    pBirthdate: string;
    pSex: number;
    pTherTypes?: string[];
    pTherapyLocation?: string[];
    pTherNum: number | null;
    pTherHowOften: number | null;
    pTherDays?: string[];
    pAvailTime1: string | null;
    pAvailTime2: string | null;
    pAvailTime3: string | null;
    pAvailTime4: string | null;
    pLanguage1: number;
    pLanguage2: number;
    pTherExperience: number | null;
    pPaymentType: number;
    pInsurance: string | null;
    pPrice?: string[];
    psStatusID: number;
    psStatusDescription: string;
    pAddress1: string | null;
    pAddress2: string | null;
    pCity: string | null;
    pState: string | null;
    pZipCode: string | null;
    pPhone: string | null;
    pEmail: string | null;
    pImg: string | null;
    pSpecialty: string | null;
    pPayorName: string;
    pPayorPolicyNo: string | null;
    pPayorGroupNo: string | null;
    pGenderReq: number;
    pmiDME: string | null;
    pmiAllergies: string | null;
    pmiDiagnosis: string | null;
}

export interface IGetPatientPayload {
    pID: string;
    uID: string;
    userType: EUserRole;
}

export interface IGetPatientMedicationsPayload {
    pID: string;
}

export enum EPatientStatusNumeric {
    Active = 1,
    Inactive = 2,
}

export interface ICreatePatientPayload {
    uID: string;
    userType: 'PatientUser';
    pFirstName: string;
    pLastName: string;
    pMiddleInit?: string | null;
    pSuffix?: string | null;
    pBirthdate: string;
    pTherTypes?: string[];
    pLanguage1?: number;
    pLanguage2?: number;
    pStatusID: EPatientStatusNumeric;
    pAddress1?: string | null;
    pAddress2?: string | null;
    pCity?: string | null;
    pState?: string | null;
    pZip?: string | null;
    pPhone?: string | null;
    pEmail?: string | null;
}

export interface IUpdatePatientPayload extends ICreatePatientPayload {
    pID: string;
    pSSISex?: string | null;
    pMDSpecialty?: string | null;
    pTherapyLocation?: string[];
    pYrsExp?: string | null;
    pFreqNum?: number | null;
    pFreq?: number | null;
    pDays?: number | null;
    pTime1?: string | null;
    pTime2?: string | null;
    pTime3?: string | null;
    pTime4?: string | null;
    pPrice?: number | null;
    pPaymentType?: string | null;
    pPayor?: string | null;
    pPayorPolicy?: string | null;
    pPayorGroup?: string | null;
    pDiagnosis?: string | null;
    pDME?: string | null;
    pSex?: number | null;
    pAllergies?: string | null;
    pMedications?: IMedication[];
}

export interface IMedication {
    MedID: number | null;
    MedName: string;
    MedDose: string;
    MedRoute: string;
    MedStart: string;
    MedEnd: string | null;
    medActive?: number;
}

export interface ICreatePatientResponse {
    pID: string;
}
